import { Result } from 'antd';
import { BackButton, GridContainer } from 'common/components/UI';

const NotFound = () => {
  return (
    <GridContainer>
      <BackButton path='/' />
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
      />
    </GridContainer>
  );
};

export default NotFound;
